import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { SearchComponent } from './search.component';

@NgModule({
	declarations: [SearchComponent],
	imports: [FormsModule, ReactiveFormsModule, SharedModule, GenericDirectivesModule],
	exports: [SearchComponent]
})
export class SearchModule { }
